module.exports = __webpack_public_path__ + "img/downarrow.fed3029e.svg";